export default "__VITE_ASSET__885a7GXg__"